angular
  .module 'filters'
  .filter 'eventDate', ->
    (input) ->
      if input
        moment(input).format('h:mma, MMMM Do YYYY')
